import { render, staticRenderFns } from "./InquiryContentsCardTelRecode.vue?vue&type=template&id=66fd0e20&"
import script from "./InquiryContentsCardTelRecode.vue?vue&type=script&lang=js&"
export * from "./InquiryContentsCardTelRecode.vue?vue&type=script&lang=js&"
import style0 from "./InquiryContentsCardTelRecode.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCard,VCardText,VCol,VContainer,VRow,VTextarea})
